import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { bannerInfo, sloganInfo, productsInfo, eventInfo } from "../VipJumbotronFunc";

const VipJumbotronV3 = ({ game_id, products, gift, area }) => {
  const paymentMethod = area === "tw" ? "信用卡、ATM轉帳、WebATM。":"信用卡、銀聯卡。";

  const special_note =
    game_id === "g66naxx2tw" ? (
      <div className="small">
        <span role="img" aria-label="sparkling stars">
          ✨ ✨ ✨ ✨ 注意 ✨ ✨ ✨ ✨
        </span>
        <br />
        <br />
        電台方案付費方式更改為藍新金流，請依表單流程執行即可。<br />
        付費方式：{paymentMethod}<br />
        <br />
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        電台方案僅適用【台灣龍邑版】<br />
        用戶若使用【<strong className="text-danger">海外全球版</strong>】，<strong className="text-danger">無法購買</strong>。<br />
        判斷方式：【<strong className="text-danger">海外全球版</strong>】遊戲APP圖示右下角<strong className="text-danger">有</strong>網易Logo角標。<br />
        需請您重新下載安裝【台灣龍邑版】後，再繼續填表單。<br />
        判斷方式：【台灣龍邑版】遊戲APP圖示<strong className="text-danger">無</strong>網易Logo角標。<br />
        <br />
        <strong className="text-danger">
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          若您欲購買未滿3000元的品項，歡迎使用
          <a target="blank" href="https://www.lifeafterpay.com/">
            <img
              width="60"
              alt="MyCard logo"
              src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
            />
          </a>
          進行儲值喔!
          <br />
        </strong>
      </div>
    ) : game_id === "G112" ? (
      <Fragment>
        <h3 className="mt-2">首儲獎勵：</h3>
        <ul>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.10,000，可額外獲得 頂級零件自選箱1個(含30零件)。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.20,000，可額外獲得 頂級零件自選箱1個(含80零件)。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.30,000，可額外獲得 頂級零件自選箱1個(含150零件)。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.49,999，可額外獲得 頂級零件自選箱1個(含250零件)。
          </li>
        </ul>
        <br />
        <h3 className="mt-2">首儲獎勵規則：</h3>
        <ul>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            首次購買方案時可獲得1次。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            每個金額的首儲次數獨立計算。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            每月1日00:00重置首儲次數。
          </li>
        </ul>
        <br />
        <br />
        <div className="small">
          <span role="img" aria-label="sparkling stars">
            ✨ ✨ ✨ ✨ 注意 ✨ ✨ ✨ ✨
          </span>
          <br />
          <br />
          本服務使用藍新金流，請依表單流程執行即可。<br />
          付費方式：{paymentMethod}<br />
          <br />
          <strong className="text-danger">
            <span role="img" aria-label="loudspeaker">
              📢
            </span>
            以上方案僅適用於【台港澳】版本。
            <br />
            <span role="img" aria-label="loudspeaker">
              📢
            </span>
            若您欲購買未滿10,000元的品項，歡迎使用
            <a target="blank" href="https://pay.longeplay.com.tw/racingmaster/topup">
              <img
                width="60"
                alt="MyCard logo"
                src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
              />
            </a>
            進行儲值喔!
            <br />
          </strong>
        </div>
      </Fragment>
    ) : game_id === "L33" ? (
      <Fragment>
        <h3 className="mt-2">每月首儲獎勵：</h3>
        <ul>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD 10,000元，可額外獲得400點券，及巨星天賦卡自選包*3，中級天賦素材*30。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD 30,000元，可額外獲得1500點券，及巨星天賦卡自選包*10，中級天賦素材*100。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD 49,999元，可額外獲得3000點券，及巨星天賦卡自選包*15，中級天賦素材*200。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD 100,000元，可額外獲得8000點券，巨星天賦卡自選包*35，中級天賦素材*500，潮人券*10。
          </li>
        </ul>
        <br />
        <h3 className="mt-2">首儲獎勵規則：</h3>
        <ul>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            首次購買方案時可獲得1次。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            每個金額的首儲次數獨立計算。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            每月1日00:00重置首儲次數。
          </li>
        </ul>
        <br />
        <br />
        <div className="small">
          <span role="img" aria-label="sparkling stars">
            ✨ ✨ ✨ ✨ 注意 ✨ ✨ ✨ ✨
          </span>
          <br />
          <br />
          本服務使用藍新金流，請依表單流程執行即可。<br />
          付費方式：{paymentMethod}<br />
          <br />
          <strong className="text-danger">
            <span role="img" aria-label="loudspeaker">
              📢
            </span>
            以上方案僅適用於【台港澳】版本。
            <br />
            <span role="img" aria-label="loudspeaker">
              📢
            </span>
            若您欲購買未滿10000元的品項，歡迎使用
            <a target="blank" href="https://pay.longeplay.com.tw/allstar/topup">
              <img
                width="60"
                alt="MyCard logo"
                src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
              />
            </a>
            進行儲值喔!
            <br />
          </strong>
        </div>
      </Fragment>
    ) : game_id === "H73" ? (
      <div className="small">
        <span role="img" aria-label="sparkling stars">
          ✨ ✨ ✨ ✨ 注意 ✨ ✨ ✨ ✨
        </span>
        <br />
        <br />
        本服務使用藍新金流，請依表單流程執行即可。<br />
        付費方式：{paymentMethod}<br />
        <br />
        <strong className="text-danger">
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          以上方案僅適用於【台港澳】版本。
          <br />
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          若您欲購買未滿10,000元的品項，歡迎使用
          <a target="blank" href="https://pay.longeplay.com.tw/oncehuman/topup">
            <img
              width="60"
              alt="MyCard logo"
              src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
            />
          </a>
          進行儲值喔!
          <br />
        </strong>
      </div>
    ) : game_id === "MA96" ? (
      <div className="small">
        本服務使用藍新金流，請依表單流程執行即可。<br />
        付費方式：{paymentMethod}<br />
        <br />
        <strong className="text-danger">
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          方案現僅適用【龍邑台港澳版本】。
          <br />
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          若您欲購買未滿5000元的品項，歡迎使用
          <a target="blank" href="https://www.neverafter-pay.tw/">
            <img
              width="60"
              alt="MyCard logo"
              src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
            />
          </a>
          進行儲值喔!
          <br />
        </strong>
      </div>
    ) : (
      <div className="small">
        <span role="img" aria-label="sparkling stars">
          ✨ ✨ ✨ ✨ 注意 ✨ ✨ ✨ ✨
        </span>
        <br />
        <br />
        小管家方案付費方式更改為藍新金流，請依表單流程執行即可。<br />
        付費方式：{paymentMethod}<br />
        <br />
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        莊園方案僅適用【亞洲服龍邑版】<br />
        用戶若使用【<strong className="text-danger">海外其他版本</strong>】，登入的角色<strong className="text-danger">無法購買</strong>。<br />
        判斷方式：【<strong className="text-danger">海外其他版本</strong>】遊戲APP圖示右下角<strong className="text-danger">有</strong>網易Logo角標。<br />
        需請您重新下載安裝【亞洲服龍邑版】後，再繼續填表單。<br />
        判斷方式：【亞洲服龍邑版】遊戲APP圖示<strong className="text-danger">無</strong>網易Logo角標，且登入畫面有龍邑Logo。<br />
        <br />
        <strong className="text-danger">
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          服務時段為10:00-17:30，若於服務時段以外儲值，將於隔日服務時間發放點數
          <br />
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          若您欲購買未滿3000元的品項，歡迎使用
          <a target="blank" href="https://pay.longeplay.com.tw/identityv/topup">
            <img
              width="60"
              alt="MyCard logo"
              src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
            />
          </a>
          進行儲值喔!
          <br />
        </strong>
      </div>
    );

  
  const banner = bannerInfo(game_id);
  const slogan = sloganInfo(game_id);
  const event_alert = eventInfo(game_id, gift);
  const products_info = productsInfo(game_id, products);
  
  // ? 'NTD.3,000，信用點 6480 贈 1788，共可獲得 8268 信用點。'
  // : '儲值NTD.3,000，共可獲得7200回聲。';
  
  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12  mt-3">{banner}</div>
        <div className="col-lg-3 mt-3"> </div>
      </div>
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12 mt-3">
          <div className="jumbotron jumbotron-fluid">
            <div className="container">
              {slogan}
              <hr className="my-4" />
              {event_alert}
              {products_info}
              {special_note}
              <p className="small">
                <strong className="text-danger">
                <span role="img" aria-label="loudspeaker">
                  📢
                </span>
                未滿18歲之購買者，將無法提供後續服務。
                  <br />
                <span role="img" aria-label="loudspeaker">
                  📢
                </span>
                交易完成後，無法進行退換貨服務。
                  <br />
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

VipJumbotronV3.propTypes = { game_id: PropTypes.string.isRequired };

export default VipJumbotronV3;
